/**
 * File: SignInPage.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.2.1
 * Created: 2025-07-23
 * Last Updated: 2026-06-22
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

// Local project files
import { TextButton } from "../components/ui/Buttons";
import { routes } from "../constants/routes";
import { signIn } from "../utils/ServiceRequests";
import AuthPrompt from "../components/forms/AuthPrompt";
import Checkbox from "../components/forms/Checkbox";
import EmailField from "../components/forms/EmailField";
import FormHeader from "../components/forms/FormHeader";
import Logo from "../components/ui/Logo";
import PasswordField from "../components/forms/PasswordField";

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function SignInPage({ schema, setIsUserAuth }) {
    const redirect = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await signIn(email, password, rememberMe);
            setIsUserAuth(true);
            redirect(routes.user.dashboard.abs);
        } catch (error) {
            alert(error.message);
        }
    };

    return (
        <>
            <article className="auth__article">
                <form className="auth__form" onSubmit={handleSubmit}>
                    <Logo isLink={true} />
                    <FormHeader {...schema.formHeader} />
                    <fieldset>
                        <EmailField email={email} setEmail={setEmail} />
                        <PasswordField
                            label={"Password"}
                            id={"password-sign-in"}
                            placeholder={"Password"}
                            password={password}
                            setPassword={setPassword}
                            isValidationHint={false}
                        />
                        <div className="sign-in__actions">
                            <Checkbox
                                id={"remember-me"}
                                label={"Remember me"}
                                checked={rememberMe}
                                onChange={setRememberMe}
                            />
                            <Link to={routes.public.auth.recovery.abs}>
                                Forgot Password?
                            </Link>
                        </div>
                    </fieldset>
                    <TextButton {...schema.textButton}></TextButton>
                    <hr></hr>
                    <AuthPrompt {...schema.authPrompt} />
                </form>
            </article>
        </>
    );
}

export default SignInPage;
